module.exports = {"410181001":"新华路街道","410181002":"杜甫路街道","410181003":"永安路街道","410181004":"孝义街道","410181005":"紫荆路街道","410181100":"米河镇","410181101":"新中镇","410181102":"小关镇","410181103":"竹林镇","410181104":"大峪沟镇","410181105":"河洛镇","410181106":"站街镇","410181108":"康店镇","410181110":"北山口镇","410181111":"西村镇","410181112":"芝田镇","410181113":"回郭镇","410181114":"鲁庄镇","410181115":"夹津口镇","410181116":"涉村镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410181.json
// module id = 1396
// module chunks = 0